/**
 * Shadow of core SearchDetails: the searched-for line without an XML-tag
 * message.
 *
 * Core formats "Searched for: <em>{searchedtext}</em>." as a rich-text
 * message. intl-messageformat 7 needs DOMParser for tags, which Node lacks, so
 * the server printed the raw template while the browser printed the term. The
 * mismatch threw React hydration errors #418/#425 on every search URL with a
 * term, and the TAIUIT browser check counted them as down from 2026-09-21
 * 05:51 UTC. Passing <em> as a value renders identically on both sides.
 */
import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  searchResults: {
    id: 'Search results',
    defaultMessage: 'Search results',
  },
});

const SearchDetails = ({ total, text, as = 'h4', data }) => {
  const El = as;
  const intl = useIntl();
  return (
    <El className="search-details">
      {text && (
        <FormattedMessage
          id="Searched for: {searchedtext}."
          defaultMessage="Searched for: {searchedtext}."
          values={{ searchedtext: <em>{text}</em> }}
        />
      )}
      {data.showTotalResults && (
        <>
          {' '}
          {intl.formatMessage(messages.searchResults)}: {total}
        </>
      )}
    </El>
  );
};

export default SearchDetails;
